import { render, staticRenderFns } from "./DashboardRouteCard.vue?vue&type=template&id=70301fa3&scoped=true"
import script from "./DashboardRouteCard.vue?vue&type=script&lang=js"
export * from "./DashboardRouteCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardRouteCard.vue?vue&type=style&index=0&id=70301fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70301fa3",
  null
  
)

export default component.exports